import { types } from 'mobx-state-tree';

const CursorStore = types
  .model('CursorStore', {
    globalState: types.optional(types.enumeration(['next', 'prev', 'play', 'hidden', '']), ''),
  })
  .actions(self => ({
    setNext: () => {
      self.globalState = 'next';
    },

    setPrev: () => {
      self.globalState = 'prev';
    },

    setPlay: () => {
      self.globalState = 'play';
    },

    setHidden: () => {
      self.globalState = 'hidden';
    },

    setNone: () => {
      self.globalState = '';
    },
  }));

export default CursorStore;



// WEBPACK FOOTER //
// ./src/stores/CursorStore.js